import { createSlice } from "@reduxjs/toolkit"

const initialState = {
  isFullPageView: false
}

export const sliceName = "policyDocument"

export const policyDocumentSlice = createSlice({
  initialState,
  name: sliceName,
  reducers: {
    toggleExpandOnClick: (state, action) => {
      state.isFullPageView = !state.isFullPageView
    },
    endExpandOnPageChange: (state, action) => {
      state.isFullPageView = false
    }
  }
})


export const { endExpandOnPageChange, toggleExpandOnClick } = policyDocumentSlice.actions

export const isFullPageViewData = state => state[sliceName].isFullPageView

export default policyDocumentSlice.reducer